import styled, { css, keyframes } from 'styled-components';

import { ImageBackgroundLogoIbFullscreen } from '~/assets/images';

const appearOpacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const ModalContainer = styled.div`
  p {
    color: #fff;
    text-align: center;
  }

  button {
    margin-top: 3rem;

    width: 100%;
    height: 58px;
    background: transparent linear-gradient(107deg, #ffd503 0%, #ffdf22 100%) 0%
      0% no-repeat padding-box;
    border-radius: 50px;

    text-transform: uppercase;
    font-size: 2.5rem;
    font-weight: bold;

    transition: opacity 0.2s;

    :hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 425px) {
    width: 90%;
  }
`;

export const ModalTitle = styled.h1`
  width: 100%;
  font-size: 3rem;
  text-align: center;
  color: #fff;

  margin-bottom: 2.2rem;

  /* font-size: 2rem; */
`;

export const Container = styled.div`
  background: url(${ImageBackgroundLogoIbFullscreen}) 0% / cover fixed,
    ${(props) => props.theme.colors.background};

  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 45.3rem;

  padding: 2rem;

  animation: ${appearOpacity} 0.5s ease-in;

  @media (min-width: 768px) {
    padding: 0;
  }

  /* Logo */
  > svg {
    margin-top: 5.6rem;
  }

  > form {
    width: 100%;
    margin: 2.2rem 0;

    > div {
      & + div {
        margin-top: 2.2rem;
      }
    }
  }
`;

type TitleProps = {
  secondary?: boolean;
};

export const Title = styled.h1<TitleProps>`
  font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
  font-size: 3.8rem;
  color: ${({ theme }) => theme.colors.yellow};

  text-align: center;

  margin-top: 3.6rem;

  width: 98%;

  ${({ secondary }) =>
    secondary &&
    css`
      color: #fff;
      font-size: 3rem;
    `}
`;

export const FormButton = styled.button`
  margin-top: 3rem;

  width: 100%;
  height: 58px;
  background: transparent linear-gradient(107deg, #ffd503 0%, #ffdf22 100%) 0%
    0% no-repeat padding-box;
  border-radius: 50px;

  text-transform: uppercase;
  font-size: 2.5rem;
  font-weight: bold;

  transition: opacity 0.2s;

  :hover {
    opacity: 0.8;
  }
`;

export const RememberedContainer = styled.div`
  width: 100%;
  /* max-width: 29.8rem; */

  font-size: 1.6rem;
  color: #ffffff;

  text-align: center;

  margin: 3.6rem 0 9.2rem 0;

  > button {
    font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
    background: none;
    color: inherit;

    transition: ${({ theme }) => theme.transition.default};

    &:hover {
      color: ${({ theme }) => theme.colors.yellow};
    }
  }
`;
